import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-min-h-[calc(100vh-80px)] tw-w-full tw-overflow-x-hidden" }
const _hoisted_2 = {
  key: "loading-state",
  class: "tw-flex tw-items-center tw-justify-center tw-py-16"
}
const _hoisted_3 = {
  key: "admin-content",
  class: "tw-space-y-3"
}
const _hoisted_4 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50 tw-p-3 sm:tw-p-4" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-3 md:tw-flex-row md:tw-items-center md:tw-justify-between" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-gap-0.5 tw-min-w-0" }
const _hoisted_7 = { class: "tw-text-sm tw-text-slate-700" }
const _hoisted_8 = { class: "tw-flex tw-flex-col tw-gap-0.5 tw-min-w-0 md:tw-flex-1 md:tw-px-6" }
const _hoisted_9 = { class: "tw-text-sm tw-text-slate-800" }
const _hoisted_10 = { class: "tw-flex md:tw-justify-end" }
const _hoisted_11 = { class: "tw-space-y-4" }
const _hoisted_12 = { class: "tw-flex tw-justify-end tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Users = _resolveComponent("Users")!
  const _component_GoogleAddressInput = _resolveComponent("GoogleAddressInput")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createBlock(_component_ListPage, { variant: "page" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tw-mb-4 tw-w-full tw-border-b tw-border-white/40 tw-bg-white/35 tw-backdrop-blur-md tw-shadow-sm tw-shadow-slate-900/5 tw-py-4" }, [
          _createElementVNode("div", { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1" }, [
            _createElementVNode("div", { class: "tw-text-center" }, [
              _createElementVNode("h1", { class: "tw-text-2xl sm:tw-text-3xl tw-font-semibold tw-tracking-tight tw-text-slate-800" }, "Admin"),
              _createElementVNode("div", { class: "tw-mt-1 tw-text-sm tw-text-slate-600" }, "Company settings and user management.")
            ])
          ])
        ], -1)),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_font_awesome_icon, {
                icon: "circle-notch",
                spin: "",
                class: "tw-h-10 tw-w-10 tw-text-slate-400"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "Company", -1)),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.company?.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Company address", -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.companyAddress || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAddressModal && _ctx.openAddressModal(...args))),
                      class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5 hover:tw-bg-white"
                    }, " Update company address ")
                  ])
                ])
              ]),
              _createVNode(_component_Users, { company: _ctx.company }, null, 8, ["company"])
            ]))
      ]),
      _createVNode(_component_Modal, {
        isOpen: _ctx.isAddressModalOpen,
        "onUpdate:isOpen": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isAddressModalOpen) = $event)),
        modalId: "admin-address-modal",
        maxWidth: "lg",
        onClose: _ctx.closeAddressModal
      }, {
        title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createTextVNode("Update company address", -1)
        ]))]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_GoogleAddressInput, {
              id: "admin_company_address",
              modelValue: _ctx.draftCompanyAddress,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.draftCompanyAddress) = $event)),
              label: "Company address",
              placeholder: "Start typing company address...",
              onAddressSelected: _ctx.handleAddressSelection
            }, null, 8, ["modelValue", "onAddressSelected"]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                class: "tw-inline-flex ...",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeAddressModal && _ctx.closeAddressModal(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: "tw-inline-flex ...",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)))
              }, "Save")
            ])
          ])
        ]),
        _: 1
      }, 8, ["isOpen", "onClose"])
    ]),
    _: 1
  }))
}